'use client';

import { useRouter } from 'next/navigation';

import { FaGift } from 'react-icons/fa6';

import { routes } from '@/features/v2/constants/routes';
import { core } from '@/features/v2/home/components/privateHome/components/cardCarousel/localization/core';
import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

const CardSportTournamet = () => {
  const router = useRouter();

  return (
    <div className="flex flex-col gap-6 px-2 w-80 h-60">
      <div className="flex bg-hbackground rounded-lg p-1 pr-3 items-center gap-4 w-2/3">
        <span className="bg-primary-500 flex justify-center items-center rounded-sm p-1">
          <FaGift size={20} className="text-black" />
        </span>
        <span className="font-medium text-sm capitalize text-primary-900">
          {core.cardsCarousel[3].boxTitle}
        </span>
      </div>
      <h4 className="text-2xl font-bold text-primary-900 font-title">
        {core.cardsCarousel[3].title}
        <span className="text-primary-500">
          {core.cardsCarousel[3].tilteSpan}
        </span>
      </h4>
      <p className="text-base text-primary-900 font-text leading-tight">
        {core.cardsCarousel[3].text}
        <span className="font-bold pe-2">
          {core.cardsCarousel[3].textSpan}
        </span>
        {core.cardsCarousel[3].continueText}
      </p>
      <div className="absolute bottom-6 left-1 w-40">
        <HButton
          mode="secondary"
          size="large"
          label={core.cardsCarousel[3].buttonText}
          disabled={false}
          onPress={() => {
            router.push(`${routes.TOURNAMENTS}/deportes`);
          }}
        />
      </div>
    </div>
  );
};

export default CardSportTournamet;
